import { Table } from "@kyan/ui";

import { getColumns } from "./Overview.config";
import { useOverviewController } from "./Overview.controller";

export const Overview = () => {
  const { data, isLoading } = useOverviewController();
  const columns = getColumns();

  return (
    <Table
      hideHeader
      data={data}
      columns={columns}
      isLoading={isLoading}
      classes={{
        wrapper: "h-17.5 overflow-y-hidden",
        table: "border-b-0",
        row: "border-t-0 border-b px-8 h-17.5",
        cellClassName: "py-5",
        loading: {
          wrapper: "px-8 border-b border-divider border-t-0 h-17.5",
          skeleton: "size-full rounded-lg",
        },
      }}
    />
  );
};
